import { lmcOptionType } from "./types";
import { useRef } from "react";
import QRCodeGenerator from "../../../atoms/QRCodeGenerator";
import LinkActions from "../../../molecules/LinkActions";

const ResultLmcCard = ({
  lmc,
  processId,
}: {
  lmc: lmcOptionType;
  processId: string;
}) => {
  const qrGeneratorRef = useRef<any>(null);
  const loyaltyProgramUrl = `${process.env.REACT_APP_HOST_URL}/process/${processId}`;

  return (
    <div className="w-full">
      <div className="w-full mb-4 flex justify-center items-center border border-gray-200 rounded-lg p-2">
        <QRCodeGenerator
          ref={qrGeneratorRef}
          data={loyaltyProgramUrl}
          size={250}
          showLogo={true}
          logoUrl="https://cdn.1cdn.app/application/UMD/2405110558455_logo.png"
          ariaLabel={`QR code for LMC campaign: ${lmc}`}
        />
      </div>

      <LinkActions
        url={loyaltyProgramUrl}
        qrGeneratorRef={qrGeneratorRef}
        downloadFileName={`${lmc}_${processId}_qr.png`}
      />
    </div>
  );
};

export default ResultLmcCard;
